export const REQUEST_TIMEOUT = process.env.REQUEST_TIMEOUT || 30000;
export const MAP_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const MAP_ID = process.env.REACT_APP_GOOGLE_MAP_ID;
